import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSplit } from '@travel-frontend/split-io';
import { useHeaderHandlers } from '../../../components/Header/context/index.js';
import { HeaderFavorite } from '../../../components/HeaderFavorite/index.js';
export const FavoriteWrapper = props => {
  const {
    treatment: favoriteTreatment
  } = useSplit('FPO_6430_wishlist_feature_toggle');
  const isFavoriteActive = favoriteTreatment === 'on';
  const {
    onFavoriteClick
  } = useHeaderHandlers();
  return isFavoriteActive ? _jsx(HeaderFavorite, {
    onClick: onFavoriteClick,
    ...props
  }) : null;
};